import React from 'react'

function GroceriesItem ({list}) {
    return (
        list.map((item, index) => {
            return (
                <li key={index}>
                    <div className="title lx-fz22 lx-fw600">{ item.title }</div>
                    <div className="content lx-fz16">{ item.content }</div>
                </li>
            )
        })
    ) 
}

export default GroceriesItem;